import { batch } from 'react-redux'
import { customizeError } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { checkIfForeignDni } from '../../modules/utils/helpers'
import { getLegalSuitability } from '../../services/suitability'
import { getStartDateActivitySii } from '../../services/sii'

export const GET_LEGAL_SUITABILITY = 'GET_LEGAL_SUITABILITY'
export const GET_LEGAL_SUITABILITY_ERROR = 'GET_LEGAL_SUITABILITY_ERROR'
export const GET_LEGAL_SUITABILITY_SUCCESS = 'GET_LEGAL_SUITABILITY_SUCCESS'
export const onGetLegalSuitability = makeActionCreator(GET_LEGAL_SUITABILITY)
export const onGetLegalSuitabilityError = makeActionCreator(GET_LEGAL_SUITABILITY_ERROR, 'payload')
export const onGetLegalSuitabilitySuccess = makeActionCreator(GET_LEGAL_SUITABILITY_SUCCESS, 'payload')
export const onGetLegalSuitabilityThunk =
  ({ dni, callback = () => undefined }) =>
  async (dispatch, getState) => {
    dispatch(onGetLegalSuitability())

    try {
      const { dni: legalSuitabilityDni } = getState().legalSuitability
      if (dni === legalSuitabilityDni) {
        return batch(() => {
          dispatch(onGetLegalSuitabilitySuccess())
          callback()
        })
      }

      const { data } = await getLegalSuitability({
        actionType: GET_LEGAL_SUITABILITY,
        dni,
        isForeign: checkIfForeignDni(dni) ? 1 : 0
      })

      const creationDate = new Date(
        `${data?.payload?.fechaInicio.substring(6, 10)}-${data?.payload?.fechaInicio.substring(
          3,
          5
        )}-${data?.payload?.fechaInicio.substring(0, 2)}T00:00:00.000`
      )

      return batch(() => {
        dispatch(
          onGetLegalSuitabilitySuccess({
            dni,
            societyType: data?.payload?.tipoSociedad,
            creationDate,
            source: data?.payload?.fuente || 'SII'
          })
        )
        callback()
      })
    } catch (error) {
      let reason
      switch (error.code) {
        case 401:
          reason = 'UNAUTHORIZED_ERROR'
          break
        case 403:
          reason = 'FORBIDDEN_ERROR'
          break
        default:
          reason = 'SOMETHING_WENT_WRONG_ERROR'
          break
      }

      return batch(() => {
        dispatch(
          onGetLegalSuitabilityError({
            dni,
            error: customizeError({ originalError: error?.originalError, code: error?.code, reason }).toObject()
          })
        )
        callback()
      })
    }
  }

export const GET_START_DATE_ACTIVITY = 'GET_START_DATE_ACTIVITY'
export const GET_START_DATE_ACTIVITY_ERROR = 'GET_START_DATE_ACTIVITY_ERROR'
export const GET_START_DATE_ACTIVITY_SUCCESS = 'GET_START_DATE_ACTIVITY_SUCCESS'
export const onGetStartDateActivity = makeActionCreator(GET_START_DATE_ACTIVITY)
export const onGetStartDateActivityError = makeActionCreator(GET_START_DATE_ACTIVITY_ERROR, 'payload')
export const onGetStartDateActivitySuccess = makeActionCreator(GET_START_DATE_ACTIVITY_SUCCESS, 'payload')
export const onGetStartDateActivityThunk = payload => async dispatch => {
  dispatch(onGetStartDateActivity())

  try {
    const { data } = await getStartDateActivitySii({ actionType: GET_START_DATE_ACTIVITY, dni: payload.dni })

    return dispatch(
      onGetStartDateActivitySuccess({
        startDateActivity: data?.payload?.fechaInicioActividad
      })
    )
  } catch (error) {
    // FIXME: this checks should goes inside the factoryService implementation.
    // It will be fixed in v2 of react-kit.
    if (error?.originalError?.code === 'ERR_CANCELED') {
      return
    }

    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      case 403:
        // A 403 error means that the token is public or that it's a seller trying to access information that it can not see
        reason = 'FORBIDDEN_ERROR'
        break
      case 404:
        reason = 'DNI_DOES_NOT_MATCH_ERROR'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }

    return dispatch(
      onGetStartDateActivityError({
        error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
      })
    )
  }
}
